import Box from '@mui/material/Box'
import Icon from '@mui/material/Icon'
import Typography from '@mui/material/Typography'
import Modal from '@mui/material/Modal'
import AdxButton from 'components/custom/AdxButton'

const AdxInfoModal = ({
  variant,
  muiIcon,
  iconColor = 'information.main',
  title = 'This is title',
  subtitle = 'This is subtitle',
  modalWidth = '550px',
  horizontalOrientation,
  children,
  footerButtons, // enable standardized footerButtons
  firstBtnHandle,
  firstBtnLabel,
  firstBtnLoading,
  firstBtnDisabled,
  secondBtnHandle,
  secondBtnLabel,
  secondBtnLoading,
  secondBtnDisabled,
  thirdBtnHandle,
  thirdBtnLabel,
  thirdBtnLoading,
  thirdBtnDisabled,
  ...rest
}) => {
  let firstBtnVariant
  let secondBtnVariant
  let thirdBtnVariant

  switch (variant) {
    case 'standard':
      firstBtnVariant = 'contained'
      secondBtnVariant = 'ghost'
      thirdBtnVariant = 'ghost'
      break
    case 'standard_logo':
      firstBtnVariant = 'contained'
      secondBtnVariant = 'ghost'
      thirdBtnVariant = 'ghost'
      break
    case 'warning':
      firstBtnVariant = 'contained'
      secondBtnVariant = 'ghost'
      thirdBtnVariant = 'ghost'
      break
    case 'error':
      firstBtnVariant = 'contained-destructive'
      secondBtnVariant = 'ghost-destructive'
      thirdBtnVariant = 'ghost-destructive'
      break
    default:
      firstBtnVariant = 'contained'
      secondBtnVariant = 'ghost'
      thirdBtnVariant = 'ghost'
      break
  }

  return (
    <Modal {...rest}>
      <Box
        bgcolor={'white.main'}
        width={{ xs: 'calc(100% - 30px)', tablet: modalWidth }}
        borderRadius={'10px'}
        boxSizing={'border-box'}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          boxShadow: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 4,
          p: 3,
        }}
      >
        {muiIcon && (
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            width={'90px'}
            height={'90px'}
            borderRadius={'50%'}
            bgcolor="default-background.main"
          >
            <Icon
              sx={{
                color: iconColor,
                fontSize: 48,
              }}
            >
              {muiIcon}
            </Icon>
          </Box>
        )}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography
              align="center"
              variant="h4"
              fontWeight="bold"
              letterSpacing={{ xs: -0.5, mobile_l: 0 }} //letter spacing in actual mobile device looks quite wide, hence the -0.5
              color="dark-text.main"
              sx={{
                '&:first-letter': {
                  textTransform: 'uppercase',
                },
              }}
            >
              {title}
            </Typography>
            {subtitle && (
              <Typography
                align="center"
                variant="body1"
                color="light-gray-text.main"
                sx={{
                  '&:first-letter': {
                    textTransform: 'uppercase',
                  },
                }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
        </Box>
        {children && (
          <Box display="flex" flexDirection="column" alignItems="center" sx={{ gap: 1, width: 1 }}>
            {children}
          </Box>
        )}
        {footerButtons && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: 1 }}>
            {firstBtnLabel && (
              <AdxButton
                variant={firstBtnVariant}
                disabled={firstBtnDisabled}
                isLoading={firstBtnLoading}
                onClick={firstBtnHandle}
                sx={{ width: 1 }}
              >
                {firstBtnLabel}
              </AdxButton>
            )}
            {secondBtnLabel && (
              <AdxButton
                variant={secondBtnVariant}
                disabled={secondBtnDisabled}
                isLoading={secondBtnLoading}
                onClick={secondBtnHandle}
                sx={{ width: 1 }}
              >
                {secondBtnLabel}
              </AdxButton>
            )}
            {thirdBtnLabel && (
              <AdxButton
                variant={thirdBtnVariant}
                disabled={thirdBtnDisabled}
                isLoading={thirdBtnLoading}
                onClick={thirdBtnHandle}
                sx={{ width: 1 }}
              >
                {thirdBtnLabel}
              </AdxButton>
            )}
          </Box>
        )}
      </Box>
    </Modal>
  )
}

export default AdxInfoModal
